import { omit, set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { createFetchManyHandler } from '../../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../../helpers/pagination';
import { fetchOnHoldReservations } from '../../../sagas/components/on-hold-reservations/routines';
import { updateReservationStatus } from '../../../../Reservation/sagas/routines';
import { CANCELED } from '../../../../../constants/reservation/Status';
import {
  clearOnHoldReservations,
  onHoldReservationsOnChangePage,
  onHoldReservationsOnChangeOrder
} from '../../../actions/components/on-hold-reservations';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'requestTime:desc'
};

const clearOnHoldReservationsHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    fetched: false,
    saved: false,
    pagination: resetPaginationState(state.pagination)
  })
});

const onHoldReservationsOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const onHoldReservationsOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

const updateReservationStatusHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    if (response && response.status === CANCELED) {
      const totalCount = state.pagination.totalCount || 0;
      return {
        ...state,
        all: omit(response.id, state.all),
        pagination: {
          ...state.pagination,
          totalCount: Math.max(0, totalCount - 1)
        }
      };
    }
    return state;
  },
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchOnHoldReservations),
  ...clearOnHoldReservationsHandler(clearOnHoldReservations),
  ...onHoldReservationsOnChangePageHandler(onHoldReservationsOnChangePage),
  ...onHoldReservationsOnChangeOrderHandler(onHoldReservationsOnChangeOrder),
  ...updateReservationStatusHandler(updateReservationStatus)
});
